/* BBL Hype Day — shared behaviour for bbl-hype-* sections.
   Countdown: any element with [data-hy-countdown="ISO date"] gets ticked.
   Live state: when the target passes, elements with [data-hy-live-text] swap their text,
   and the document gets class "hy-sale-live" so sections can restyle. */
(function () {
  "use strict";
  if (window.__bblHype) return; window.__bblHype = true;
  var pad = function (n) { return String(n).padStart(2, "0"); };

  function readTargets() {
    var nodes = document.querySelectorAll("[data-hy-countdown]");
    return Array.prototype.map.call(nodes, function (el) {
      return { el: el, target: new Date(el.getAttribute("data-hy-countdown")).getTime() };
    });
  }

  function render(item) {
    var diff = Math.max(0, item.target - Date.now());
    var d = Math.floor(diff / 864e5); diff -= d * 864e5;
    var h = Math.floor(diff / 36e5); diff -= h * 36e5;
    var m = Math.floor(diff / 6e4); diff -= m * 6e4;
    var s = Math.floor(diff / 1e3);
    var el = item.el;
    var live = item.target - Date.now() <= 0;
    if (el.hasAttribute("data-hy-short")) {
      el.textContent = live ? (el.getAttribute("data-hy-live-text") || "LIVE")
        : (d > 0 ? d + "d " : "") + pad(h) + ":" + pad(m) + ":" + pad(s);
    } else {
      var q = function (k) { return el.querySelector("[data-" + k + "]"); };
      if (q("d")) q("d").textContent = pad(d);
      if (q("h")) q("h").textContent = pad(h);
      if (q("m")) q("m").textContent = pad(m);
      if (q("s")) q("s").textContent = pad(s);
    }
    if (live) goLive();
  }

  var isLive = false;
  function goLive() {
    if (isLive) return;
    isLive = true;
    document.documentElement.classList.add("hy-sale-live");
    document.querySelectorAll("[data-hy-live-html]").forEach(function (el) {
      el.innerHTML = el.getAttribute("data-hy-live-html");
    });
    document.querySelectorAll("[data-hy-live-href]").forEach(function (el) {
      el.setAttribute("href", el.getAttribute("data-hy-live-href"));
    });
    document.querySelectorAll("[data-hy-live-label]").forEach(function (el) {
      el.textContent = el.getAttribute("data-hy-live-label");
    });
  }

  function init() {
    var items = readTargets();
    if (!items.length) return;
    var tick = function () { items.forEach(render); };
    tick();
    setInterval(tick, 1000);
  }

  /* Sticky CTA: show on small screens once the hero form scrolls out */
  function sticky() {
    var bar = document.querySelector("[data-hy-sticky]");
    var form = document.querySelector("[data-hy-form]");
    if (!bar || !form || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var done = !!form.querySelector(".done");
      var show = !en.isIntersecting && !done && window.innerWidth < 900;
      bar.classList.toggle("show", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
    }, { threshold: 0.1 }).observe(form);
  }

  /* Smooth scroll to the form from any CTA */
  function jumpLinks() {
    document.querySelectorAll('a[href="#hy-early-access"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var form = document.getElementById("hy-early-access");
        if (!form) return;
        e.preventDefault();
        form.scrollIntoView({ behavior: "smooth", block: "center" });
        var email = form.querySelector('input[type="email"]');
        if (email) setTimeout(function () { email.focus({ preventScroll: true }); }, 500);
      });
    });
  }

  /* Ambient glow canvases */
  function glow(c, a, b) {
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var ctx = c.getContext("2d"), w, h, t = 0;
    var blobs = [0, 1, 2, 3].map(function (i) {
      return { x: Math.random(), y: Math.random(), r: .35 + Math.random() * .3, sp: .15 + Math.random() * .2, ph: i * 1.7 };
    });
    function size() { w = c.width = c.clientWidth * (window.devicePixelRatio || 1); h = c.height = c.clientHeight * (window.devicePixelRatio || 1); }
    function draw() {
      ctx.clearRect(0, 0, w, h);
      blobs.forEach(function (bl, i) {
        var x = (bl.x + Math.sin(t * bl.sp + bl.ph) * .12) * w, y = (bl.y + Math.cos(t * bl.sp * .8 + bl.ph) * .1) * h, r = bl.r * Math.max(w, h) * .6;
        var g = ctx.createRadialGradient(x, y, 0, x, y, r);
        g.addColorStop(0, i % 2 ? b : a); g.addColorStop(1, "rgba(11,11,12,0)");
        ctx.fillStyle = g; ctx.fillRect(x - r, y - r, r * 2, r * 2);
      });
      t += .016; if (!reduce) requestAnimationFrame(draw);
    }
    size(); window.addEventListener("resize", size); draw();
  }
  function glows() {
    document.querySelectorAll("canvas[data-hy-glow]").forEach(function (c) {
      var warm = c.getAttribute("data-hy-glow") === "teal";
      glow(c, warm ? "rgba(37,90,114,.35)" : "rgba(2,196,255,.22)", warm ? "rgba(2,196,255,.18)" : "rgba(37,90,114,.35)");
    });
  }

  function boot() { init(); sticky(); jumpLinks(); glows(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  /* Re-run inside the theme editor when a section is re-rendered */
  document.addEventListener("shopify:section:load", boot);
})();
